import {
    App, Button, Flex, Row, Typography,
} from 'antd';

import React, { useState, useEffect, } from "react";
import PanelFrameWithImage from "./PanelFrameWithImage";
import { imageLocations } from "../image/ImageLocations";
import { useTranslation } from "react-i18next";
import useOnlineStatus from "../../utility/hooks/useOnlineStatus";
import { getSessionData, } from "../../utility/global-util";
import { getTyreConfiguration, } from "../../api/maintenance";
import { showApiError } from "../../utility/error/error-handler";
import { useScreenSizeBelow } from "../../utility/hooks/useScreenSize";
import RecordTyreRequest from '../../sections/tyre_request/RecordTyreRequest';
import { getDriver } from '../../api/driver';


const ManageTyresPanel = ({vehicle, backgroundType, }) => {
    const { Text } = Typography;
    const { notification } = App.useApp();
    const { t } = useTranslation();
    const { isOnline } = useOnlineStatus();
    const [loadingProgress, setLoadingProgress] = useState(0);  //start 0 - button shows loading if less than 100
    const [tyreConfiguration, setTyreConfiguration] = useState(null);
    const [tyreRequestModalVisible, setTyreRequestModalVisible] = useState(false);
    const [submitProgress, setSubmitProgress] = useState(100);  //start 100 - button shows loading if less than 100
    const [driver, setDriver] = useState({});
    const [currentTyreRequest, setCurrentTyreRequest] = useState( {} );

    const currentContract = getSessionData('currentContract');

    let contractAccount = '';
    let contractEntity = '';
    if (currentContract) {
        contractAccount = currentContract.accountCode ? currentContract.accountCode : '';
        contractEntity = currentContract.entityId ? currentContract.entityId : '';
    }    
    
    useEffect(() => {
        if (isOnline) {
            getDriver()
            .then(res => {
                setDriver(res);

            }, )
            .catch(err => showApiError(t('title.driver_details'), err, notification));

            if (contractEntity && contractAccount) {
                getTyreConfiguration(contractEntity, 'C', contractAccount, setLoadingProgress)
                .then(res => {
                    setTyreConfiguration(res);
                    })
                .catch(err => showApiError(t('title.tyre_replacements'), err, notification));
            }
        } else {
            // OFFLINE
            setLoadingProgress(100);
        }
    }, [t, notification, contractEntity, contractAccount, setLoadingProgress, isOnline]);



    const Buttons = ({currentTab}) => {
    
        return (
          <div>
              <Flex gap="small" wrap>
                 {
                 isOnline
                 ?
                 <Button type="primary" loading={loadingProgress !== 100 && !vehicle} onClick={(e) => showTyreRequestModal(e)}>
                   {t('title.tyre_request')}
                 </Button>
                 :
                 <></>
                 }              
              </Flex>
          </div>
        );
      } 

      const showTyreRequestModal = (e) => {
        setTyreRequestModalVisible(true);
    };

    const TyreInstructionMessage = ({message}) => {
        return (
                <table style={{marginBottom:"15px"}}>
                  <tbody>
                    <tr>
                        <td>
                          {
                            <Text > { message } </Text>
                          }
                        </td>
                    </tr>
                  </tbody>
                </table>
               )
      }

    const PanelMessage = () => {
        let displayHeight=130;
    
        if (useScreenSizeBelow(992)) {
            displayHeight = null;
        }

        return (
                <div style={{height: displayHeight, overflow:'auto'}}>
                    <TyreInstructionMessage message={tyreConfiguration?.driverTyreInstructionNote}> </TyreInstructionMessage>
                </div>
               )
      }


    return (
        <div> 
            {
                <PanelFrameWithImage title={t('title.tyre_replacements')}
                                     imageLocation={imageLocations.TYRE_REPLACEMENT_IMAGE}
                                     backgroundType={backgroundType} height="260px"
                                     buttons={<Buttons />}
                >
                    <Row>
                        <PanelMessage></PanelMessage>
                    </Row>            
                </PanelFrameWithImage>
            }

            <RecordTyreRequest isModalVisible={tyreRequestModalVisible}
                               setIsModalVisible={setTyreRequestModalVisible}
                               loadingProgress={loadingProgress}
                               setLoadingProgress={setLoadingProgress}
                               submitProgress={submitProgress}
                               setSubmitProgress={setSubmitProgress}
                               vehicle={vehicle}
                               driver={driver}
                               currentTyreRequest={currentTyreRequest}
                               setCurrentTyreRequest={setCurrentTyreRequest}
            >
            </RecordTyreRequest>
        </div>
    );
}

export default ManageTyresPanel;